import React from 'react';
import Loadable from '../../components/loadable';

const ReactTemplateEditor = Loadable({
  loader: () => import('../../components/template_editor'),
  loading: () => <div className="loading-placeholder" style={{ height: 600, marginBottom: 15 }} />,
});

angular.module('shared').value('ReactTemplateEditor', ReactTemplateEditor);
